/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimVisualReferenceVisualReference } from './TimVisualReferenceVisualReference';
import {
    TimVisualReferenceVisualReferenceFromJSON,
    TimVisualReferenceVisualReferenceFromJSONTyped,
    TimVisualReferenceVisualReferenceToJSON,
    TimVisualReferenceVisualReferenceToJSONTyped,
} from './TimVisualReferenceVisualReference';

/**
 * 
 * @export
 * @interface TimVisualReference
 */
export interface TimVisualReference {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    date: string;
    /**
     * 
     */
    citation: string;
    /**
     * 
     */
    visual_reference: TimVisualReferenceVisualReference;
}

/**
 * Check if a given object implements the TimVisualReference interface.
 */
export function instanceOfTimVisualReference(value: object): value is TimVisualReference {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('citation' in value) || value['citation'] === undefined) return false;
    if (!('visual_reference' in value) || value['visual_reference'] === undefined) return false;
    return true;
}

export function TimVisualReferenceFromJSON(json: any): TimVisualReference {
    return TimVisualReferenceFromJSONTyped(json, false);
}

export function TimVisualReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimVisualReference {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': json['date'],
        'citation': json['citation'],
        'visual_reference': TimVisualReferenceVisualReferenceFromJSON(json['visual_reference']),
    };
}

export function TimVisualReferenceToJSON(json: any): TimVisualReference {
    return TimVisualReferenceToJSONTyped(json, false);
}

export function TimVisualReferenceToJSONTyped(value?: TimVisualReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': value['date'],
        'citation': value['citation'],
        'visual_reference': TimVisualReferenceVisualReferenceToJSON(value['visual_reference']),
    };
}

